import React, { useMemo } from "react";
import client from "@culturehq/client";
import { Loader, Table } from "@culturehq/components";

import { useProfile } from "app/context";
import { useFetch } from "app/hooks";
import { t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import PageHeader from "components/display/PageHeader";

import RecognitionWidget from "./RecognitionWidget";
import SurveyWidget from "./SurveyWidget";
import LeaderboardWidget from "./LeaderboardWidget";
import WidgetRow from "./WidgetRow";
import NoWidgets from "./NoWidgets";

const widgetsFrom = (announcements, { widgetOrder, recognitionsEnabled, surveysEnabled }) => {
  const widgets = [];

  if (recognitionsEnabled && (!widgetOrder || typeof widgetOrder.recognition !== "number")) {
    widgets.push({ id: "recognition" });
  }

  if (surveysEnabled && (!widgetOrder || typeof widgetOrder.survey !== "number")) {
    widgets.push({ id: "survey" });
  }

  if (!widgetOrder || typeof widgetOrder.leaderboard !== "number") {
    widgets.push({ id: "leaderboard" });
  }

  return [...widgets, ...announcements];
};

const WidgetRows = ({ widgets }) => (
  widgets.map(widget => {
    switch (widget.id) {
      case "recognition":
        return <RecognitionWidget key="recognition" disabled />;
      case "survey":
        return <SurveyWidget key="survey" disabled />;
      case "leaderboard":
        return <LeaderboardWidget key="leaderboard" disabled />;
      default:
        return <WidgetRow key={widget.id} widget={widget} disabled />;
    }
  })
);

const WidgetDisabledList = () => {
  const { profile } = useProfile();

  const onFetch = () => client.listAnnouncements({ active: false });
  const { error, fetching, json: { announcements = [] } } = useFetch(onFetch);

  const widgets = useMemo(
    () => widgetsFrom(announcements, profile.organization),
    [announcements, profile]
  );

  return (
    <>
      <PageHeader title={t("Manage Widgets")}>
        <Trans>
          Create widgets to display featured content to certain groups. Sort the
          order of widgets to determine which ones display on top.
        </Trans>
      </PageHeader>

      {error && <ErrorMessage error={error} />}

      <Loader loading={fetching}>
        <Table>
          <thead>
            <tr>
              <th />
              <th><Trans>Created</Trans></th>
              <th><Trans>Header</Trans></th>
              <th><Trans>Message</Trans></th>
              <th><Trans>Display</Trans></th>
              <th className="pull-right">
                <Trans>Actions</Trans>
              </th>
            </tr>
          </thead>
          <tbody>
            <WidgetRows widgets={widgets} />
          </tbody>
        </Table>

        {!widgets.length && <NoWidgets />}
      </Loader>
    </>
  );
};

export default WidgetDisabledList;
